// extracted by mini-css-extract-plugin
module.exports = {"fullScreenLoading":"FullScreenLoading_fullScreenLoading__2Ohh_"};